import { useEffect, useState } from 'react'
import { Package } from '../../../models'

const usePackage = (packageId) => {
  const [pack, setPackage] = useState(null)

  useEffect(() => {
    if (!packageId) return

    Package
      .find(packageId)
      .then((res) => setPackage(res.data))
  }, [packageId])

  return pack
}

export default usePackage
